import script from "./TcVsSidebar.vue?vue&type=script&lang=ts&setup=true"
export * from "./TcVsSidebar.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__